import s from "./_getMapData.js";
function h(a, e) {
  var t = s(this, a), i = t.size;
  return t.set(a, e), this.size += t.size == i ? 0 : 1, this;
}
export {
  h as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_mapCacheSet.js
// module id = 1537
// module chunks = 67